import { Link } from '@tanstack/react-router'
import type { DetailedAssessment } from '../types'
import { Card, CardHeader, CardTitle } from '@/components/ui/card'

interface AssessmentInfoCardsProps {
  assessment: DetailedAssessment
}

export function AssessmentInfoCards({ assessment }: AssessmentInfoCardsProps) {
  const assessmentType = assessment.assessmentType
  const position = assessmentType?.position

  return (
    <>
      <Card className="p-6 bg-muted/30 rounded-lg border-none shadow-none">
        <CardHeader className="space-y-3 p-0">
          <div>
            <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1">
              Assessment Type
            </div>
            <CardTitle className="text-xl">
              {assessmentType?.name ?? 'Unknown'}
            </CardTitle>
          </div>
          {position && (
            <div className="space-y-1.5 pt-2 border-t">
              <div className="flex items-center gap-2 text-sm">
                <span className="text-muted-foreground font-medium">
                  Position:
                </span>
                <a
                  className="font-semibold text-primary"
                  href={`/positions/?role=${encodeURIComponent(
                    position.role,
                  )}&level=${encodeURIComponent(
                    position.level,
                  )}&positionId=${encodeURIComponent(
                    position.id,
                  )}&title=${encodeURIComponent(
                    position.title,
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {position.title}
                </a>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <span className="text-muted-foreground font-medium">Level:</span>
                <a
                  className="font-semibold text-primary"
                  href={`/positions/?role=${encodeURIComponent(
                    position.role,
                  )}&level=${encodeURIComponent(
                    position.level,
                  )}&positionId=${encodeURIComponent(
                    position.id,
                  )}&title=${encodeURIComponent(
                    position.title,
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {position.level}
                </a>
              </div>
            </div>
          )}
        </CardHeader>
      </Card>
      <Card className="p-6 bg-muted/30 rounded-lg border-none shadow-none">
        <CardHeader className="space-y-3 p-0">
          <div>
            <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1">
              Assessment Details
            </div>
            <CardTitle className="text-xl">
              {assessment.createdAt
                ? new Date(assessment.createdAt).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })
                : 'Date unavailable'}
            </CardTitle>
          </div>
          <div className="space-y-1.5 pt-2 border-t">
            {assessment.manager && (
              <div className="flex items-center gap-2 text-sm">
                <span className="text-muted-foreground font-medium">
                  Manager:
                </span>
                <Link
                  className="font-medium text-primary"
                  to="/direct-reports/$directReportId/career-path"
                  params={{ directReportId: assessment.manager.id }}
                  search={{ name: assessment.manager.name || undefined }}
                >
                  {assessment.manager.name ?? assessment.manager.email}
                </Link>
              </div>
            )}
            {assessment.employee && (
              <div className="flex items-center gap-2 text-sm">
                <span className="text-muted-foreground font-medium">
                  Assessee:
                </span>
                <Link
                  className="font-medium text-primary"
                  to="/direct-reports/$directReportId/career-path"
                  params={{ directReportId: assessment.employee.id }}
                  search={{ name: assessment.employee.name || undefined }}
                >
                  {assessment.employee.name ?? assessment.employee.email}
                </Link>
              </div>
            )}
          </div>
        </CardHeader>
      </Card>
    </>
  )
}
